import React from 'react';

import { Modal } from 'src/components/common';
import { ResubscribeEmailModalContent } from 'src/components/emailTracker';
import { useModalV2 } from 'src/hooks/shared';
import { ModalV2Props } from 'src/types/modalV2';

export const ResubscribeEmailModal: React.FC<ModalV2Props<unknown>> = ({ id }) => {
  const { closeModal, switchClosability } = useModalV2();

  const handleCloseModal = React.useCallback(() => {
    closeModal(id);
  }, [closeModal, id]);

  return (
    <Modal
      title="Resubscribe Email"
      maxWidth={550}
      headerPadding="32px 32px 8px 32px"
      dialogProps={{
        onClose: handleCloseModal,
        open: true,
      }}
    >
      <ResubscribeEmailModalContent
        onCloseModal={handleCloseModal}
        switchClosability={switchClosability}
      />
    </Modal>
  );
};
